import React from 'react';
import Recaptcha from 'react-recaptcha';
import { Controller, useFormContext } from 'react-hook-form';
import ValidationErrorMessage from './ValidationErrorMessage';
import PropTypes from 'prop-types';

/**
 * Component to render the google ReCaptcha
 *
 * @param name see PropTypes
 * @param reCaptchaRef see PropTypes
 * @returns {JSX.Element}
 * @component
 */
const ReCaptcha = ({ name, reCaptchaRef }) => {

  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <div className="d-flex flex-column mt-8">
      {
        errors[name] &&
        <ValidationErrorMessage error={errors[name]}/>
      }
      <div className="mt-2">

        <Controller
          control={control}
          name={name}
          id={name}
          rules={{ required: 'Please complete the reCAPTCHA challenge' }}
          render={({ field: { onChange, ref } }) => (
            <Recaptcha
              ref={(e) => {
                ref(e);
                reCaptchaRef.current = e;
              }}
              sitekey={process.env.REACT_APP_HE_RECAPTCHA_KEY}
              verifyCallback={onChange}
            />
          )}
        />
      </div>
    </div>
  );
};

ReCaptcha.propTypes = {
  /**
   * The input name
   */
  name: PropTypes.string.isRequired,

  /**
   * The reCAPTCHA ref initialised in the donation form.
   */
  reCaptchaRef: PropTypes.object.isRequired,

};

export default ReCaptcha;